const messages = {
  name: 'Account |||| Accounts',

  fields: {
    accountName: 'Account Name',
    accountStatus: 'Account Status',
    application: 'Application',
    contactCenterReplyToEmail: "Hotel's reply-to email",
    maxUsers: 'Maximum users',
    userScopes: 'Permissions on this account',
    license: 'License',
    licenseValidity: 'License Validity',
    licenseBlocked: 'LicenseBlocked',
    rateLimitApplies: 'Rate Limit Applies',
    log: 'Log',
    rateLimitPerMin: 'Rate Limit/Min',
    rateLimitPerDay: 'Rate Limit/Day',
    whitelistApplies: 'White List Applies',
    provider: 'Provider',
    providers: 'Provider(s)',
    applications: 'Application(s)',
    credits: 'Credits',
    templatifyAccount: 'Templatify account',
    groups: 'Groups',
    users: 'Users',
    costCenter: 'Cost Center',
    apiKey: 'API Key',
    aiAvailable: 'The account can use AI',
    aiProvider: 'AI Provider',
    aiApiKey: 'LLM API Key',
    aiTranscriptionApiKey: 'Transcription API Key (Groq Whisper)',
    validityTimeFrame: 'License Validity Time Frame',
    loggingStrategy: 'Logging Strategy',
    logRetentionDays: 'Log Retention (days)',
    logRetentionDaysPlaceholder: 'Platform default',
    logRetentionDaysHelp: 'Empty = platform default (global keep-until)',
    communicationTypes: 'Communication Types',
    communicationType: 'Communication Type',
    name: 'Name',
    surname: 'Surname',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    userId: 'User Id',
    deviceType: 'Device Type',
    token: 'Token',
    platform: 'Platform',
    emailAddress: 'Email Address',
    number: 'Number',
    chatId: 'Chat ID',
    rmkTemplateAccountName: 'Rmk Template Account Name',
    rmkTemplateApiKey: 'RMK Template API Key',
    templatifyAccountName: 'Templatify account name',
    templatifyGroup: 'Templatify group',
    templatifyApiKey: 'Templatify api-key',
    templatifyApplications: 'Templatify application',
    ipAddress: 'IP Address',
  },

  filters: {
    accountName: 'Account Name',
    application: 'Application',
    provider: 'Provider',
    costCenter: 'Cost Center',
  },

  registry: {
    label: 'Organization registry',
    kindProperty: 'Property',
    kindOrganization: 'Organization',
    chip: 'Linked',
    optional: 'Choose the property or organization the account belongs to.',
    optionalNow: 'Link the account to its registry record. It cannot be changed afterwards.',
    locked: 'The account is already linked to its registry record.',
    linked: 'Account linked successfully',
    conflict: 'The account is already linked to another record.',
    failed: 'The account could not be linked. Please try again.',
  },

  sections: {
    general: 'GENERAL',
    configuration: 'CONFIGURATION',
    ai: 'ARTIFICIAL INTELLIGENCE',
    templatify: 'TEMPLATIFY',
    options: 'OPTIONS',
  },

  options: {
    useTemplatify: 'Use Templatify',
    contactCenterEnabled: 'Connect contracted',
    portalEnabled: 'Customer portal contracted',
    automationsEnabled: 'Flow contracted',
    blockedLicense: 'Blocked License',
    rateLimitApplies: 'Rate Limit Applies',
    whitelistApplies: 'Whitelist Applies',
    addUsers: 'Add Users',
    useTemplates: 'Use Templates',
    useCostCenter: 'Use Cost Center',
  },

  status: {
    active: 'Active',
    limited: 'Limited',
    blocked: 'Blocked',
  },

  logging: {
    none: 'None',
    wrong: 'Wrong',
    all: 'All',
  },

  channels: {
    email: 'Email',
    sms: 'SMS',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    push: 'Push',
  },

  tabs: {
    accountInfo: 'Account Information',
    templatifyIntegration: 'Templatify Integration',
    applications: 'Applications',
  },

  templatify: {
    autoCreate: {
      title: 'Auto-create Templatify account',
      description: 'A matching Templatify account will be created via API when you save',
    },
    createNew: {
      title: 'Create new account',
      description: 'Creates a new Templatify account with the same name',
    },
    linkExisting: {
      title: 'Link to existing account',
      description: 'Connect to an account that already exists in Templatify',
    },
    validate: {
      credentialsOk: 'Connection verified',
      templates: 'Templates',
      action: 'Validate',
      success: 'Templatify account verified',
      failed: 'Could not validate the account in Templatify',
      verified: 'Account verified in Templatify',
    },
    updateApiKey: {
      title: 'Update the Api Key in Templatify',
      description:
        'Enter a new API key to update the Templatify integration. This will replace the existing key used for authentication and application sync.',
      confirmTitle: 'Are you sure you want to update the Templatify API Key?',
      confirmMessage:
        'This action will replace the existing key used for authentication and application sync.',
      confirmYes: 'Yes, update it',
      confirmNo: 'No, keep existing key',
    },
    accessGlobal: {
      title: 'Access to global templates',
      description:
        'This account will be able to use templats marked as global in Templatify',
          readonly: 'Current setting of the Templatify account',
    },
    syncNote: 'Account data syncs between Notify and Templatify. Existing Templatify templates are preserved.',
  },

  applications: {
    assignedTitle: 'Assigned Applications',
    addApplication: 'Add Application',
    notify: 'Notify',
    templatify: 'Templatify',
    tagNotify: 'NOTIFY',
    tagViaApi: 'VIA API',
    selectPlaceholder: 'Select application',
    syncStatus: {
      existsInBoth: 'Exists in both',
      notifyOnly: 'Notify only',
      willCreateInNotify: 'Will create in Notify',
      willCreateInTemplatify: 'Will create in Templatify',
    },
  },

  groups: {
    manageTitle: 'Manage Groups',
    noticeTitle: 'Notice',
    noticeBody: 'Groups and GroupMembers are assigned to Applications only in Notify, not in Templatify.',
    addGroup: 'Add Group',
    paste: 'Paste',
    copySuccess: 'Group copied to clipboard',
    pasteSuccess: 'Group pasted successfully',
    groupName: 'Group Name',
    addMember: 'Add Group Member',
    memberTitle: 'Group Member Details',
    channelsHeading: 'Notification Channels',
    noGroups: 'No Groups',
    pickApplicationsFirst: 'Link at least one application (Account Information or Templatify Integration) to manage its groups.',
  },

  actions: {
    addAccount: 'Add Account',
    exportCsv: 'Export CSV',
    addToken: 'Add Token',
    addEmail: 'Add Email',
    addNumber: 'Add Number',
    addChatId: 'Add Chat ID',
    addIpField: 'Add Ip Field',
    addUser: 'Add User',
    copyApiKey: 'Copy API Key',
    regenerateApiKey: 'Regenerate API Key',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    discard: 'Discard',
    remove: 'Remove',
  },

  placeholders: {
    expirationDateTime: 'Expiration Date & Time',
    dateFormat: 'DD/MM/YYYY',
  },

  help: {
    contactCenterReplyToEmail:
      "The hotel's real mailbox. Set as Reply-To on outgoing mail so guest replies reach the hotel (always visible, even when the contact center is part-time). The hotel forwards that mailbox to {account}@inbox... so the CC ingests them too.",
    sensitiveApiKeyOnEdit: 'Leave empty to keep the existing key',
    maxUsers: 'Empty or 0 = no limit. Once reached, the account cannot create more users.',
    noProductsContracted: 'This account has no product contracted yet: tick portal, Connect or Flow above to be able to grant permissions.',
    scopeCatalogUnavailable: 'The permission list could not be loaded. Reload the page; if it persists, the server is not serving it.',
    aiApiKey: 'Key for the LLM provider (Gemini, Groq or OpenRouter) used by the AI features.',
    aiTranscriptionApiKey:
      'Optional. If the provider is Groq it can be left empty and the LLM key is reused.',
    aiTranscriptionNeededForOpenRouter:
      'OpenRouter does not transcribe audio. Without a Groq Whisper key here, guest voice notes will NOT be transcribed: the message keeps its placeholder and nobody gets an error.',
    passwordComplexity:
      'Password must have at least one uppercase letter, one lowercase letter, one digit and one special character.',
  },

  validation: {
    required: '%{field} is required',
    apiKeyRequired: 'API Key is required',
    applicationRequired: 'Application is required',
    rateLimitGtZero: '%{field} should be greater than 0',
    logRetentionMin: 'Log retention must be 0 or more days',
    pastDateNotAllowed: 'License Validity Time Frame cannot be in the past',
    passwordsMismatch: 'Passwords do not match',
    passwordMinLength: 'Password must be at least %{min} characters',
    passwordPattern:
      'Password must have uppercase, lowercase, a number, and a symbol.',
  },

  wizard: {
    stepOf: 'Step',
    fixErrors: 'Some required fields are missing — check the highlighted step',
    untitled: 'Untitled account',
    accountInfoDesc: 'Name, providers, license & apps',
    accountAccess: 'Account access',
    accountAccessDesc: 'Rate limits & IP whitelist',
    users: 'Users',
    usersDesc: 'Optional account users',
    costCenter: 'Cost center',
    costCenterDesc: 'Credit billing assignment',
    applicationsDesc: 'Linked applications',
    groups: 'Groups',
    groupsDesc: 'Notification groups per app',
    templatifyDesc: 'Template rendering account',
  },

  usersDialog: {
    editScopes: 'Permissions on this account',
    scopesSaved: 'Permissions saved.',
    noScopes: 'No permissions',
    title: 'Users — %{name}',
    empty: 'This account has no users.',
    hint: 'These users sign in with SSO to the customer portal and the contact center of this account.',
    add: 'Add user',
    email: 'Email',
    name: 'First name',
    surname: 'Last name',
    password: 'Temporary password (empty = reset email; min. 12 chars, uppercase, digit and symbol)',
    phone: 'Phone',
    telegramChatId: 'Telegram chat ID',
    removeFromAccount: 'Remove from this account',
    create: 'Create',
    created: 'User created and added to the account.',
    deleteTitle: 'Remove %{email} from the account?',
    deleteContent: 'They lose access to this account. If they belong to no other account, their SSO user is fully deleted.',
    deleted: 'User removed.',
    disabled: 'Disabled',
    impersonate: 'Impersonate',
    impersonateTitle: 'Open as %{name}',
    impersonateHint: 'Open the portal or the contact center acting as this user, using your SuperUser session. Support use only.',
    portal: 'Portal',
    contactCenter: 'Connect',
  },

  apiKeysDialog: {
    title: 'API keys — %{name}',
    hint: 'Each key can be bound to one application (pins the app of the send) or work for the whole account. The scope decides which part of the API it reaches.',
    empty: 'This account has no API keys.',
    new: 'New API key',
    colLabel: 'Label',
    colApplication: 'Application',
    colScope: 'Scope',
    colTest: 'Test',
    colStatus: 'Status',
    colActions: 'Actions',
    wholeAccount: 'Whole account',
    wholeAccountOption: 'Whole account (all apps)',
    testBadge: 'Test',
    active: 'Active',
    revoked: 'Revoked',
    scope: {
      manage: 'Manage',
      send: 'Send',
      automations: 'Flow',
    },
    scopeHint: {
      manage: 'The whole API. Includes delivery logs, credits, account data and contact center.',
      send: 'Send notifications only.',
      automations: 'Create and update bookings only. This is what a PMS needs.',
    },
    rotate: 'Rotate',
    revoke: 'Revoke',
    reactivate: 'Reactivate',
    createTitle: 'New API key',
    editTitle: 'Edit API key',
    labelField: 'Label',
    applicationField: 'Application',
    scopeField: 'Scope',
    testField: 'Test key',
    created: 'API key created.',
    updated: 'API key updated.',
    rotated: 'API key rotated — a new secret was generated.',
    reactivated: 'API key reactivated.',
    deleted: 'API key deleted.',
    revokedMsg: 'API key revoked.',
    revealTitle: 'API key "%{label}"',
    revealWarning: 'Save it now — it will not be shown again.',
    copy: 'Copy',
    copied: 'API key copied to clipboard.',
    revealDone: 'I saved it',
    deleteTitle: 'Delete the API key "%{label}"?',
    deleteContent: 'It stops working immediately. This action cannot be undone.',
  },

  rowMenu: {
    accountInfo: 'Account info',
    viewUsers: 'View users',
    apiKeys: 'API keys',
    block: 'Block',
    unblock: 'Unblock',
    costCenter: 'Cost center',
    creditTransactions: 'Credit transactions',
  },

  info: {
    title: 'Account info',
    general: 'General',
    license: 'License',
    limits: 'Rate limits',
    whitelist: 'Whitelisted IPs',
    applications: 'Applications',
    providers: 'Providers',
    groups: 'Groups',
    users: 'Users',
    channels: 'Channels',
    none: '—',
    yes: 'Yes',
    no: 'No',
  },

  notifications: {
    created: 'Account created successfully',
    updated: 'Account updated successfully',
    blocked: 'Account blocked',
    unblocked: 'Account unblocked',
    statusUpdateFailed: 'Could not update the account status',
    deleted: '%{name} deleted successfully',
    loadFailed: 'Failed to load account',
    saveFailed: 'Failed to save account',
    apiKeyCopied: 'API Key copied to clipboard',
    rmkApiKeyCopied: 'RMK Template API Key copied to clipboard',
  },

  delete: {
    title: 'Delete %{recordName}?',
    content: 'Are you sure you want to delete this account? This action cannot be undone.',
  },

  account: { title: 'Account Details' },
};

export default messages;
